import { isAfter } from 'date-fns/isAfter';
import { isDate } from 'date-fns/isDate';
import get from 'lodash/get';

import { AbstractSpecification } from './specification';

export class DateAfterSpecification<T> extends AbstractSpecification<T> {
   constructor(private compareDate: Date | string, private propertyPath: string) {
      super();
   }

   isSatisfiedBy = (candidate: T | undefined): boolean => {
      if (candidate === undefined) return false;
      const objectProperty = get(candidate, this.propertyPath);
      if (!objectProperty || !isDate(objectProperty)) return false;
      return isAfter(objectProperty, this.compareDate);
   };
}
